// .pen: l0ufNB (ds/selfie/next-step)
import { Link } from 'react-router-dom';
import {
  ArrowRight,
  Shield,
  Target,
  Wallet,
  ShoppingCart,
  TrendUp,
  PiggyBank,
  CreditCard,
  GridFour,
} from '@phosphor-icons/react';

import pt from '../../../locales/pt';
import { buildNextSteps } from '../../../lib/reportUiUtils';
import { resolveReportStepLink } from '../../../lib/reportModulePaths';
import { ReportSectionHeading } from './ReportPrimitives';

const MODULE_ICONS = {
  patrimonio: TrendUp,
  orcamento: GridFour,
  objetivos: Target,
  'fundo-emergencia': Shield,
  despesas: ShoppingCart,
  rendimentos: Wallet,
  cofres: PiggyBank,
  dividas: CreditCard,
};

/**
 * Camada 3 — passos acionáveis com link para a área da app.
 */
export function SelfieReportNextSteps({ report, nextPeriodLabel }) {
  const steps = buildNextSteps(report);
  if (!steps.length) return null;

  const heading = nextPeriodLabel
    ? pt.snapshots.report.layers.nextStepsFor.replace('{period}', nextPeriodLabel)
    : pt.snapshots.report.layers.nextSteps;

  return (
    <section aria-labelledby="report-next-steps-heading">
      <ReportSectionHeading id="report-next-steps-heading" eyebrow={heading} />
      <div className="mt-space-3 flex flex-col gap-space-3">
        {steps.map((step) => {
          const link = resolveReportStepLink(step);
          if (!link) return null;
          const module = step.related_module;
          const Icon = (module && MODULE_ICONS[module]) || Target;

          return (
            <Link
              key={`${step.title}-${link.path}`}
              to={link.path}
              className="flex items-start gap-space-3 rounded-ds-lg border border-border bg-card p-space-4 transition-colors hover:border-sage-300 hover:bg-sage-50/50 dark:hover:border-sage-700 dark:hover:bg-sage-950/20"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-ds-md bg-sage-tint text-sage-on-tint">
                <Icon className="h-[18px] w-[18px]" aria-hidden />
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-type-body font-semibold text-foreground">{step.title}</p>
                {step.body ? (
                  <p className="mt-0.5 text-type-body-sm leading-snug text-muted-foreground">
                    {step.body}
                  </p>
                ) : null}
                <span className="mt-space-1 inline-flex items-center gap-1 text-type-body-sm font-semibold text-sage-on-tint">
                  {link.label}
                  <ArrowRight className="h-3.5 w-3.5" aria-hidden />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default SelfieReportNextSteps;
